import { Controller } from 'stimulus'
import { trackEvent } from '../../src/javascripts/tracking'

export default class extends Controller {
  static targets = ["results"]
  static values = {
    comparisonId: String,
    themeCount: Number,
    totalVotes: Number,
    userHasVoted: Boolean
  }

  connect() {
    // Track page visit
    trackEvent('Visited Team Voting Page', {
      'comparisonId': this.comparisonIdValue,
      'themeCount': this.themeCountValue,
      'totalVotes': this.totalVotesValue,
      'userHasVoted': this.userHasVotedValue,
      'isFirstVoter': this.totalVotesValue === 0
    });
  }

  resultsTargetConnected() {
    // Track when voting results are displayed
    this.trackVotingResults()
  }

  trackVoteButtonClick(event) {
    // Track when user clicks to vote for an activity
    const themeName = event.currentTarget.closest('.bg-white').querySelector('h3').textContent.trim()

    trackEvent('Clicked Vote Button', {
      'comparisonId': this.comparisonIdValue,
      'themeName': themeName,
      'themeCount': this.themeCountValue,
      'totalVotes': this.totalVotesValue,
      'userHasVoted': this.userHasVotedValue,
      'isChangeVote': this.userHasVotedValue
    });
  }

  trackVoteSubmission(event) {
    // Track actual vote submission
    const form = event.target
    const formData = new FormData(form)
    const themeId = formData.get('team_vote[theme_id]')

    // Find theme name from the form context
    const themeCard = document.querySelector(`[data-theme-id="${themeId}"]`)
    const themeName = themeCard ? themeCard.querySelector('h3')?.textContent?.trim() : 'Unknown'

    trackEvent('Submitted Team Vote', {
      'comparisonId': this.comparisonIdValue,
      'themeName': themeName,
      'themeId': themeId,
      'voterName': formData.get('team_vote[voter_name]'),
      'voterEmail': formData.get('team_vote[voter_email]'),
      'themeCount': this.themeCountValue,
      'totalVotes': this.totalVotesValue,
      'userHasVoted': this.userHasVotedValue,
      'isChangeVote': this.userHasVotedValue
    }, {send_immediately: true}); // Use send_immediately for conversion events
  }

  trackVotingResults() {
    // Track when user views voting results
    trackEvent('Viewed Voting Results', {
      'comparisonId': this.comparisonIdValue,
      'themeCount': this.themeCountValue,
      'totalVotes': this.totalVotesValue,
      'userHasVoted': this.userHasVotedValue
    });
  }
}